<template>
  <div>
    <transition-group name="fade">
      <p v-if="message" class="alert alert-success" key="message" role="alert">
        {{ message }}
      </p>
      <p
        v-if="error && getType(error) === 'string'"
        key="error"
        class="alert alert-danger"
        role="alert"
      >
        {{ error }}
      </p>
      <ul
        v-if="getType(error) === 'object'"
        class="alert alert-danger"
        key="error-list"
      >
        <li v-for="key in errorKeys" :key="key">
          <!-- <b class="font-bold capitalize">{{ key | titleCase }}</b> -->
          <ul class="ml-2">
            <li v-for="(item, index) in getErrors(key)" :key="`${index}-error`">
              {{ item }}
            </li>
          </ul>
        </li>
      </ul>
    </transition-group>
  </div>
</template>

<script>
export default {
  name: "FlashMessage",
  props: {
    message: {
      type: String,
      default: null,
    },
    error: {
      type: [Object, String],
      default: null,
    },
  },
  computed: {
    errorKeys() {
      if (!this.error || this.getType(this.error) === "string") {
        return null;
      }
      return Object.keys(this.error);
    },
  },
  methods: {
    getErrors(key) {
      return this.error[key];
    },
    getType(obj) {
      return Object.prototype.toString.call(obj).slice(8, -1).toLowerCase();
    },
  },
  filters: {
    titleCase(value) {
      return value.replace("_", " ");
    },
  },
};
</script>